import React from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";
import { highlightBarLabel, highlightSeatTitle } from "./voHighlights";

export default function VoHighlightsBar({ items = [], onOpen }) {
  if (!items.length) return null;
  return (
    <Box
      data-vo-highlights-bar="1"
      sx={{
        position: "relative",
        pointerEvents: "auto",
        width: "100%",
        px: { xs: 1.1, md: 1.25 },
        py: { xs: 0.75, md: 0.9 },
        borderRadius: 2,
        bgcolor: "rgba(28, 22, 14, 0.8)",
        border: "1px solid rgba(232,196,138,0.28)",
        backdropFilter: "blur(10px)",
        textAlign: "left",
      }}
    >
      <Typography sx={{ fontSize: "0.78rem", fontWeight: 800, color: "#e8c48a" }}>
        Selos do dia
      </Typography>
      <Typography
        sx={{
          fontSize: "0.66rem",
          color: "#d7cfc4",
          mb: 0.7,
          display: { xs: "none", sm: "block" },
        }}
      >
        Quem se destacou hoje — clique para reagir ou falar
      </Typography>
      <Stack direction="row" spacing={0.6} flexWrap="wrap" useFlexGap>
        {items.map((item) => (
          <Chip
            key={`${item.kind}-${item.userId}`}
            size="small"
            clickable
            title={highlightSeatTitle(item)}
            onClick={() => onOpen?.(item)}
            label={highlightBarLabel(item)}
            sx={{
              fontWeight: 700,
              color: "#3a2414",
              bgcolor: "#e8c48a",
              cursor: "pointer",
              "&:hover": { bgcolor: "#f3d7a8" },
            }}
          />
        ))}
      </Stack>
    </Box>
  );
}
